import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  DeleteUld,
  EditUld,
  EndScan,
  NewSecurityScreen,
  NewUld,
  ScannerMaintenance,
  TestPackage,
  TransferUld,
} from '../../models/common/data.model';

@Injectable({
  providedIn: 'root',
})
export class DataUtils {
  // Only Read
  packageHistory$ = new BehaviorSubject(null);
  transferUld$ = new BehaviorSubject<TransferUld | null>(null);
  newUld$ = new BehaviorSubject<NewUld | null>(null);
  editUld$ = new BehaviorSubject<EditUld | null>(null);
  deleteUld$ = new BehaviorSubject<DeleteUld | null>(null);
  //Only Read
  uploadTrackingNumbers$ = new BehaviorSubject(null);
  endOutboundScan$ = new BehaviorSubject<EndScan | null>(null);
  newSecurityScreen$ = new BehaviorSubject<NewSecurityScreen | null>(null);
  //Only Read
  testPackage$ = new BehaviorSubject<TestPackage | null>(null);
  //Only Read
  scannerMaintenance$ = new BehaviorSubject<ScannerMaintenance | null>(null);
}
